import React, { useState, useEffect } from "react";
import { Title } from "../../components/title/title.component";
import { Grid, Typography} from "@mui/material";
import Button from "../../components/button/button.component";
import "./subscribe.styles.scss";
import InputSelect from "../../components/input-select/input-select.component";
import { getDays, getMonths } from "../../utils/getData";

export const Subscribe = (props) => {
    const gift = props.gift;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if(gift) urlParams.set("gift","yes");
    const today = new Date();
    const [title] = useState(`When is the due date?`);
    const [subTitle] = useState(`Enter the approximate due date, or enter the baby’s birthday.`);
    const years = [{value: today.getFullYear(), label:today.getFullYear()}, {value: today.getFullYear()+1, label:today.getFullYear()+1}];
    const months = getMonths();
    const [days, setDays] = useState(getDays());
    const [chosenDate, setChosenDate] = useState({year:"", month:"", day:""});
    const [url, setUrl] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    useEffect(()=>{
        setErrorMsg("");
        setUrl("");
        const now = new Date();
        now.setHours(0,0,0,0);
        const nowArr = {year: now.getFullYear(), month: now.getMonth()+1, day: now.getDate()}
        let error = false;
        if(chosenDate.year && chosenDate.month){
            if(chosenDate.year === nowArr.year && chosenDate.month <= nowArr.month){
                if(chosenDate.month < nowArr.month) error = true;
                else if(chosenDate.day && chosenDate.day < nowArr.day) error = true;
            }
            let day = chosenDate.day;

            if(!day) day=days[days.length-1].value;
            let dueDate = new Date(`${chosenDate.year}/${chosenDate.month}/${day}`);

            let daysBetween = (dueDate.getTime() - now.getTime()) / (1000 * 3600 * 24); 
            window.sessionStorage.setItem("dueDate",`${chosenDate.year}-${("0"+chosenDate.month).slice(-2)}-${chosenDate.day?("0"+chosenDate.day).slice(-2):day}`);
            setUrl(`${chooseUrl(daysBetween, gift)}${window.location.search?"&"+window.location.search.substr(1):""}`);
        }
    },[chosenDate, days, gift]);

    useEffect(()=>{
        if(chosenDate.month === 2){
            let d = new Date(chosenDate.year, chosenDate.month-1, 29);
            let yearMatches = d.getUTCFullYear() === chosenDate.year;
            let monthMatches = d.getUTCMonth() === chosenDate.month-1;
            let dayMatches = d.getUTCDate() === 29;
            if(yearMatches&&monthMatches&&dayMatches) setDays(getDays(29));
            else setDays(getDays(28));
        }else if(chosenDate.month===6 ||chosenDate.month===9 ||chosenDate.month===11 ||chosenDate.month===4) {
            setDays(getDays(30));
        } else {
            setDays(getDays(31));
        }
        setChosenDate(previous=>({...previous, day:""}));
    }, [chosenDate.year, chosenDate.month])

    const chooseUrl = (daysBetween, gift=false) =>{
        let nextURL="";
        if( daysBetween < -90){
            nextURL = "/subscribe-plans/?chc=3mab";
        }else if(daysBetween >= -90 && daysBetween < 0){
            nextURL = "/subscribe-plans/?chc=1mab"
        } else if (daysBetween >= 0 && daysBetween <= 31) {
            nextURL = "/subscribe-plans/?chc=1mbb";
        } else if (daysBetween > 31 && daysBetween <= 61) {
            nextURL = "/subscribe-plans/?chc=2mbb";
        } else if (daysBetween > 61 && daysBetween <= 91) {
            nextURL = "/subscribe-plans/?chc=3mbb";
        } else if (daysBetween > 91 && daysBetween <= 122) {
            nextURL = "/subscribe-plans/?chc=4mbb";
        }else if (daysBetween > 122 && daysBetween <= 152) {
            nextURL = "/subscribe-plans/?chc=5mbb";
        } else if (daysBetween > 152 && daysBetween <= 183) {
            nextURL = "/subscribe-plans/?chc=6mbb";
        } else if (daysBetween > 183 && daysBetween <= 213) {
            nextURL = "/subscribe-plans/?chc=7mbb";
        } else if (daysBetween > 213 && daysBetween <= 244) {
            nextURL = "/subscribe-plans/?chc=8mbb";
        } else if (daysBetween > 244) {
            nextURL = "/subscribe-plans/?chc=9mbb";
        }
        if(nextURL){
            return nextURL + (gift?"&gift=yes":"");
        }else {
            return null;
        }
        
    }
    return(
        <Grid container className="subscribe-container">
            <Grid container item xs={11} justifyContent="center">
                <Title title={title} description={subTitle} img="yes" src={require('../../imgs/due_date.png')} alt="ring" style={{width: '455px', maxWidth:"72vw", marginBottom: "15px"}}></Title>
            </Grid>
            <Grid container item xs={11} md={9} justifyContent="center" >
                <Grid container item xs={12} md={5} xl={3} spacing={1} justifyContent="space-between" style={{maxWidth:"376px"}}>
                    <Grid item xs={3.5} >
                        <InputSelect label="Year" data={years} no_error={"yes"} value={chosenDate.year} 
                        onChange={(e)=>{setChosenDate({...chosenDate, year:e.target.value});}} ></InputSelect>
                    </Grid>
                    <Grid item xs={5}>
                        <InputSelect label="Month" data={months} no_error={"yes"} value={chosenDate.month} 
                        onChange={(e)=>{setChosenDate({...chosenDate, month:e.target.value})}}></InputSelect>
                    </Grid>
                    <Grid item xs={3.5}>
                        <InputSelect label="Day" data={days} no_error={"yes"} value={chosenDate.day} 
                        onChange={(e)=>{setChosenDate({...chosenDate, day:e.target.value})}}></InputSelect>
                    </Grid>
                    <Typography sx={{margin:"auto"}} className="error-message">{errorMsg}</Typography>
                </Grid>
            </Grid>
            <Grid container item xs={11} md={9} spacing={1} justifyContent="center">
                <Grid item xs={12} md={5} xl={3} style={{maxWidth:"376px"}}>
                    <Button text="CONTINUE" href={url} onClick={()=>{
                        if(!url) setErrorMsg(`Please enter the due date, or click the "No Date" button`);
                    }}></Button>
                    <Button className="btn-reverse" text={"I don't know the date"} onClick={()=>{
                        window.location.href = `/subscribe-plans/?chc=umbb&${urlParams.toString()}`
                    }}></Button>
                </Grid>
            </Grid>
        </Grid>
        )
}